<script>
import { goto, params } from '@sveltech/routify';
import Header from '../components/Header.svelte';
import Setting from '../components/Setting.svelte';
import Share from '../components/Share.svelte';
import ErrorMessage from '../components/ErrorMessage.svelte';
import PXL from '../utils/PXL.js';
import { apibase, apikey, setAPIInfo } from '../utils/config.js';

const pxl = new PXL();

$: if ($params.appkey && $params.apibase && $params.apikey) {
  setAPIInfo({
    appkey: $params.appkey,
    apibase: $params.apibase,
    apikey: $params.apikey,
  });
}
if ($params.redirect) {
  $goto($params.redirect);
}
</script>

<Header />
<slot scoped={{ pxl }}></slot>
<Setting />
<Share />
<ErrorMessage />
